import { CM_CHECKIN_STATUS_FILTERS, CmCheckinStatusFilter } from '../../types';
import { GetOrganizationMembersParams } from '../../api/useGetOrganizationMembers';
import isActiveMemberList from '../../utils/isActiveMemberList';

const isCmCheckinStatus = (value: string | null): value is CmCheckinStatusFilter =>
    !!value && CM_CHECKIN_STATUS_FILTERS.includes(value as CmCheckinStatusFilter);

/**
 * The filter narrows the list, so an unrecognised value is dropped rather than forwarded: a
 * hand-edited or stale-bookmarked one would otherwise be rejected by the backend and take the
 * whole page down with it. Only the Active tab offers the filter, so on a sibling tab it is
 * dropped too — a narrowed list with no visible control to explain it is worse than no filter.
 */
export const parseCmCheckinStatus = (
    searchParams: URLSearchParams
): Pick<GetOrganizationMembersParams, 'cm_checkin_status'> => {
    if (!isActiveMemberList(searchParams.get('list_version'))) return {};

    const status = searchParams.get('cm_checkin_status');

    return isCmCheckinStatus(status) ? { cm_checkin_status: status } : {};
};
